<p-menubar [model]="item$ | async" styleClass="cstm-menubar"></p-menubar>